import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['css'];

  connect() {
    this.render();
  }

  renderSync() {
    const map = {};
    this.cssTargets.forEach((el) => {
      el.classList.toggle('hidden', !!map[el.textContent]);
      map[el.textContent] = 'hidden';
    });
  }

  render() {
    // Iffy running order, shouldn't flicker
    window.setTimeout(() => {
      this.renderSync();
    }, 1);
    window.setTimeout(() => {
      this.renderSync();
    }, 200);
    window.setTimeout(() => {
      this.renderSync();
    }, 1000);
  }
}
